'use es6';

export var MEETING_SIDEBAR = 'MEETING_SIDEBAR';
export var SALES_EXTENSION_SIDEBAR = 'SALES_EXTENSION_SIDEBAR';
export var LIVECHAT_SIDEBAR = 'LIVECHAT_SIDEBAR';
export var LEADFLOWS_SIDEBAR = 'LEADFLOWS_SIDEBAR';
export var FORMS_SIDEBAR = 'FORMS_SIDEBAR';
export var DOCUMENTS_SIDEBAR = 'DOCUMENTS_SIDEBAR';
export var CRM_EMAIL_SIDEBAR = 'CRM_EMAIL_SIDEBAR';
export var MARKETING_FREE_EMAIL_SIDEBAR = 'MARKETING_FREE_EMAIL_SIDEBAR';
export var SKIP_SETUP = 'SKIP_SETUP';
export var PARTNER_ID = 'PARTNER_ID';
export var LANDING_PAGE_TYPE = 'LANDING_PAGE_TYPE';
export var LANDING_PAGES_SIDEBAR = 'LANDING_PAGES_SIDEBAR';
export var VIRAL_SOURCE_PORTAL_ID = 'VIRAL_SOURCE_PORTAL_ID';
export var VIRAL_SOURCE_USER_ID = 'VIRAL_SOURCE_USER_ID';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}